module.exports = __webpack_public_path__ + "img/Frame 3.398f1f1c.svg";